<section id="solucoes" class="bg-canvas/60 py-24 lg:py-32">
  <div class="site-container">
    <h2 class="mx-auto mb-16 max-w-3xl text-center text-3xl font-bold tracking-tight lg:mb-20 lg:text-4xl">
      {{ content.title }}
    </h2>

    <div class="grid grid-cols-1 gap-8 md:grid-cols-3">
      @for (item of content.items; track item.title) {
        <article class="flex flex-col rounded-xl border border-line bg-surface p-8 shadow-sm lg:p-10">
          <div class="mb-8 flex size-14 items-center justify-center rounded-lg bg-primary/5">
            <app-icon [name]="item.icon" class="text-3xl text-primary" />
          </div>
          <h3 class="mb-4 text-2xl font-bold">{{ item.title }}</h3>
          <p class="mb-6 leading-relaxed text-muted">{{ item.description }}</p>
          <div class="mt-auto border-t border-line pt-6">
            <p class="mb-2 text-[10px] font-black tracking-widest text-gold uppercase">Solução Medviz</p>
            <p class="text-sm font-bold text-primary">{{ item.solution }}</p>
            <span class="font-accent text-sm text-muted opacity-60">{{ item.seal }}</span>
          </div>
        </article>
      }
    </div>
  </div>
</section>
